const TwilioSyncClient = require('./lib/client');
const ActionTypes = require('./lib/actionTypes');
const SyncTemplates = require('./lib/syncTemplates');
const ModalityOptions = require('./lib/modalityOptions');
const AnnotationTypes = require('./lib/annotationTypes');

module.exports  = {
    TwilioSyncClient, ActionTypes, SyncTemplates, ModalityOptions, AnnotationTypes
}